/** @jsx jsx */
import { jsx } from '@emotion/react';

import { CertificateIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/product-card';

export const productCardCredit = () => {
  return {
    icon: <CertificateIcon />,
    label: _t('Credit offered'),
  };
};
